import React, { Component } from 'react';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import addToDownloadSite from '../../common/addToDownloadSite';
import TableC from '../../basicElement/TableC';
import Filter from './Filter';

class InvestigationStatistics extends Component {
    state = {
        loading: false,
        pagination: {
            current: 1,
        },
        searchParams: {},
        data: [],
    }

    filterDataWithoutObject = (params) => {
        const obj = {};
        for (let [key, value] of Object.entries(params)) {
            if (typeof value !== 'object') {
                obj[key] = value;
            }
        }
        return obj;
    }

    loadData = () =>{
        this.setState({ loading: true });
        const { pagination, searchParams } = this.state;
        const { areaParams = {} } = searchParams;
        const { current } = pagination;
          
        const params = this.filterDataWithoutObject(searchParams);
        
        const options = {
            method: 'POST',
            url: API_URL.user.queryEmpHourInvList,
            data: {
                limit: 3,
                offset: current,
                ...params,
                ...areaParams,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        const { areaParams = {} } = searchParams;
        const params = this.filterDataWithoutObject(searchParams);
        addToDownloadSite({ ...params, ...areaParams }, API_URL.user.exportEmpHourInv, 'MAN_HOURS_EXPORT');
    }

    getRender = (text, record) => {
        const { investigationName } = record;
        return investigationName === '日常管理' ? '-' : text;
    }

    getColumns = () => [{
        title: 'JDE主项目号',
        dataIndex: 'mainCode',
        key: 'mainCode',
        fixed: 'left',
        width: 100,
        render: this.getRender,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        fixed: 'left',
        width: 140,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '项目阶段',
        dataIndex: 'stageNames',
        key: 'stageNames',
        width: 100,
    }, {
        title: '大项目经理',
        dataIndex: 'pmName',
        key: 'pmName',
        width: 100,
        render: this.getRender,
    }, {
        title: '人员工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 100,
    }, {
        title: '人员姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 100,
    }, {
        title: '工作城市',
        dataIndex: 'workCity',
        key: 'workCity',
        width: 100,
    }, {
        title: '职位',
        dataIndex: 'positionName',
        key: 'positionName',
        width: 120,
    }, {
        title: '所属部门',
        dataIndex: 'enterpriseDepartmentName',
        key: 'enterpriseDepartmentName',
        width: 100,
    }, {
        title: '直线主管',
        dataIndex: 'leaderName',
        key: 'leaderName',
        width: 100,
    }, {
        title: '目前状态',
        dataIndex: 'userStatus',
        key: 'userStatus',
        width: 80,
        render: (text, record) => {
            if (text == 'LEFT') {
                return '离职';
            } else if (text == 'WORKING') {
                return '在职';
            }
        }
    }, {
        title: '研究中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 140,
        render: this.getRender,
    }, {
        title: 'JDE项目号',
        dataIndex: 'jdeCode',
        key: 'jdeCode',
        width: 100,
        render: this.getRender,
    }, {
        title: '角色',
        dataIndex: 'roleCode',
        key: 'roleCode',
        width: 80,
        render: this.getRender,
    }, {
        title: '项目确认FTE',
        dataIndex: 'fte',
        key: 'fte',
        width: 100,
    }, {
        title: '计入完工的项目确认FTE',
        dataIndex: 'finishedFte',
        key: 'finishedFte',
        width: 100,
    }, {
        title: '非项目确认FTE',
        dataIndex: 'dailyFte',
        key: 'dailyFte',
        width: 100,
    }]

    getDataSource = () => {
        const { data = [] } = this.state;
        let key = 0;
        const dataSource = [];
        
        if (data.length > 0) {
            data.map((dataItem, dataIndex) => {
                if (dataItem.summaryList.length > 0) {
                    dataItem.summaryList.map((item, index) => {
                        if (dataItem.mainCode == '合计' || dataItem.mainCode == '总计') {
                            dataItem.mainCode = <span style={{fontWeight: 'bold'}}>{dataItem.mainCode}</span>;
                            item.fte = <span style={{fontWeight: 'bold'}}>{item.fte}</span>;
                            item.finishedFte = <span style={{fontWeight: 'bold'}}>{item.finishedFte}</span>;
                            item.dailyFte = <span style={{fontWeight: 'bold'}}>{item.dailyFte}</span>;
                        }
                        dataSource.push({
                            key: key++,
                            ...dataItem,
                            ...item,
                            investigationName: dataItem.investigationName,
                            lineOfBusinessString: dataItem.lineOfBusinessString,
                            secondLineNames: dataItem.secondLineNames,
                            stageNames: dataItem.stageNames
                       });
                    })
                } else {
                    dataSource.push({
                        key: key++,
                        ...dataItem,
                        investigationName: dataItem.investigationName,
                        lineOfBusinessString: dataItem.lineOfBusinessString,
                        secondLineNames: dataItem.secondLineNames,
                        stageNames: dataItem.stageNames
                    });
                }
            });
        }
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    render() {
        const { loading, pagination } = this.state;
        const dataSource = this.getDataSource();
        pagination.pageSize = dataSource.length;
        return (
            <div>
                <Filter search={this.search} export={this.export} type="investigation" />
                <TableC
                    loading={loading}
                    scrollY={460}
                    pagination={pagination}
                    columns={this.getColumns()}
                    data={dataSource}
                    onChange={this.handleTableChange}
                />
            </div>
        )
    }
}

export default InvestigationStatistics;


// WEBPACK FOOTER //
// ./src/components/user/manHour/InvestigationStatistics.js